/* Mobile PDP behavior. Vanilla, no deps, kept small for the JS budget.
   GA4 theme events (CLAUDE.md "GA4 event contract"): reviews_*,
   cost_transparency_opened, pwyc_tier_selected, pwyc_add_to_cart. Names and
   params match the Live theme so nothing on the GA4 side breaks at cutover.
   Checkout-lifecycle events live in the Customer Events pixel, not here. */
(function () {
  var root = document.querySelector('.pdp');
  if (!root) return;

  function ga(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }

  /* Seconds on the page, shared by every event that carries it. Declared here
     rather than inside the PWYC branch, where it used to live: the non-PWYC
     cost-panel path is in a sibling branch and could not see it. */
  var pageLoad = Date.now();
  function secs() { return Math.round((Date.now() - pageLoad) / 1000); }
  function money(n) { return '$' + n; }
  /* money() is whole dollars, which is right for a PWYC price and wrong for
     a $1.11 fee. Cost-panel amounts need cents. */
  function money2(n) { return '$' + n.toFixed(2); }

  /* --- Gallery: swipe track, thumbnails as index and control ---
     scroll-snap does the paging so the swipe is real. The strip both shows how
     many images there are and jumps to one. Pinch zoom is the browser's. */
  var track = root.querySelector('[data-gallery-track]');
  var thumbs = [].slice.call(root.querySelectorAll('[data-gallery-thumb]'));
  if (track && thumbs.length) {
    var syncThumbs = function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      root.querySelectorAll('.pdp__thumb').forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
      });
    };
    track.addEventListener('scroll', syncThumbs, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var n = parseInt(t.getAttribute('data-gallery-thumb'), 10);
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      });
    });
    syncThumbs();
  }

  /* The quantity stepper and its helper are gone: quantity lives in the cart
     drawer now, so nothing on this page sets it. `qtyInput` stays because the
     PWYC path still needs a form field to submit. */
  var qtyInput = root.querySelector('[data-step-input]');

  /* --- Restock panel (sold out only) ---
     Same open/close mechanics as the PWYC drawer. Posts to the storefront
     API's /api/notify with the honeypot and the render timestamp; the server
     answers a silent success to bots, so the UI treats every 2xx the same. */
  var notify = root.querySelector('[data-notify]');
  var notifyOpenBtn = root.querySelector('[data-notify-open]');
  if (notify && notifyOpenBtn) {
    var NOTIFY_URL = 'https://front.4147r3yu.com/api/notify';
    var notifyRenderedAt = Date.now();
    var notifyForm = notify.querySelector('[data-notify-form]');
    var notifyEmail = notifyForm.querySelector('input[type="email"]');
    var notifyHp = notifyForm.querySelector('input[name="website"]');
    var notifyErr = notify.querySelector('[data-notify-error]');
    var notifySubmit = notify.querySelector('[data-notify-submit]');
    var notifyDone = notify.querySelector('[data-notify-done]');
    var notifyBusy = false;
    var notifyHint = notify.querySelector('[data-notify-hint]');
    var notifyHintEmail = notify.querySelector('[data-notify-hint-email]');
    var notifyHintYes = notify.querySelector('[data-notify-hint-yes]');
    var notifyHintNo = notify.querySelector('[data-notify-hint-no]');
    /* "Did you mean you@gmail.com?" A domain within two edits of a common
       mailbox provider is almost always a typo (a real gmail.con bounced on
       2026-09-29). Exact matches and unknown domains are left alone; the
       customer can always keep what they typed, so this never blocks. */
    var KNOWN_DOMAINS = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com',
      'aol.com', 'live.com', 'me.com', 'mac.com', 'msn.com', 'comcast.net', 'att.net',
      'verizon.net', 'sbcglobal.net', 'protonmail.com', 'proton.me', 'ymail.com',
      'googlemail.com', 'hey.com', 'mail.com', 'gmx.com', 'gmx.de', 'web.de',
      'yahoo.co.uk', 'hotmail.co.uk', 'outlook.co.uk', 'live.co.uk', 'live.ca', 'yahoo.ca',
      'hotmail.fr', 'hotmail.de', 'hotmail.es', 'hotmail.it', 'yahoo.fr', 'yahoo.de', 'yahoo.es',
      'yahoo.it', 'outlook.fr', 'outlook.de', 'outlook.es'];
    var editDistance = function (a, b) {
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i];
        for (j = 1; j <= b.length; j++) {
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        }
        prev = cur;
      }
      return prev[b.length];
    };
    var suggestEmail = function (email) {
      var at = email.lastIndexOf('@');
      if (at < 1) return '';
      var local = email.slice(0, at), domain = email.slice(at + 1).toLowerCase();
      if (KNOWN_DOMAINS.indexOf(domain) !== -1) return '';
      var best = '', bestD = 3;
      KNOWN_DOMAINS.forEach(function (k) {
        var d = editDistance(domain, k);
        if (d < bestD) { bestD = d; best = k; }
      });
      return best ? local + '@' + best : '';
    };
    var notifyHintSeenFor = '';
    /* The question stands in for the submit button while it is open. */
    var hideNotifyHint = function () {
      if (!notifyHint) return;
      notifyHint.hidden = true;
      notifySubmit.hidden = false;
    };
    var showNotifyHint = function (suggestion) {
      notifyHintEmail.textContent = suggestion;
      notifyHint.hidden = false;
      notifySubmit.hidden = true;
    };

    var openNotify = function () {
      notify.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      ga('restock_notify_open', { product_handle: notify.getAttribute('data-notify-handle') || '' });
      if (!notifyDone.hidden) return;
      setTimeout(function () { notifyEmail.focus(); }, 50);
    };
    var closeNotify = function () {
      notify.hidden = true;
      document.documentElement.style.overflow = '';
      notifyOpenBtn.focus();
    };
    var showNotifyError = function (msg) {
      notifyErr.textContent = msg;
      notifyErr.hidden = false;
    };

    notifyOpenBtn.addEventListener('click', openNotify);
    notify.querySelectorAll('[data-notify-close]').forEach(function (b) { b.addEventListener('click', closeNotify); });
    notify.addEventListener('click', function (e) { if (e.target === notify) closeNotify(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !notify.hidden) closeNotify(); });
    if (notifyHint) {
      notifyHintYes.addEventListener('click', function () {
        notifyEmail.value = notifyHintEmail.textContent;
        hideNotifyHint();
        notifyForm.requestSubmit ? notifyForm.requestSubmit() : notifyForm.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      notifyHintNo.addEventListener('click', function () {
        notifyHintSeenFor = notifyEmail.value.trim().toLowerCase();
        hideNotifyHint();
        notifyEmail.focus();
      });
      notifyEmail.addEventListener('input', hideNotifyHint);
    }

    notifyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (notifyBusy) return;
      notifyErr.hidden = true;
      var email = notifyEmail.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showNotifyError('Enter a valid email address.');
        notifyEmail.focus();
        return;
      }
      if (notifyHint) {
        var suggestion = suggestEmail(email);
        if (suggestion && email.toLowerCase() !== notifyHintSeenFor) {
          notifyHintSeenFor = email.toLowerCase();
          showNotifyHint(suggestion);
          return;
        }
        hideNotifyHint();
      }
      notifyBusy = true;
      notifySubmit.disabled = true;
      notifySubmit.textContent = 'Sending';
      fetch(NOTIFY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          sku: notify.getAttribute('data-notify-sku') || '',
          handle: notify.getAttribute('data-notify-handle') || '',
          product_id: notify.getAttribute('data-notify-product-id') || '',
          rendered_at: notifyRenderedAt,
          website: notifyHp ? notifyHp.value : ''
        })
      })
        .then(function (res) {
          if (res.status === 429) throw new Error('Too many requests in a row. Wait a moment and try again.');
          return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (r.ok && r.data && r.data.success) {
            /* The button itself says SUCCESS and stays pressed (AS, 2026-09-12);
               the done line under it carries the promise. */
            notifyEmail.disabled = true;
            notifySubmit.textContent = 'Success';
            notifySubmit.disabled = true;
            notifyDone.hidden = false;
            notifyOpenBtn.textContent = 'Success';
            notifyOpenBtn.disabled = true;
            ga('restock_notify_submitted', { product_handle: notify.getAttribute('data-notify-handle') || '' });
          } else {
            showNotifyError((r.data && r.data.error) || 'Something went wrong. Try again.');
          }
        })
        .catch(function (err) {
          showNotifyError(err.message || 'Something went wrong. Try again.');
        })
        .then(function () {
          notifyBusy = false;
          if (notifyForm.hidden || notifySubmit.textContent === 'Success') return;
          notifySubmit.disabled = false;
          notifySubmit.textContent = 'Notify me';
        });
    });
  }

  /* --- Sticky bar: shadow only while pinned ---
     position: sticky gives no state of its own. With bottom: 0 the bar is
     pinned exactly when its bottom edge is cut by the viewport bottom, so a
     1px-inset root margin makes the observer report < 1 while stuck. */
  var bar = root.querySelector('[data-sticky-cta]');
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-stuck', entries[0].intersectionRatio < 1);
    }, { threshold: [1], rootMargin: '0px 0px -1px 0px' }).observe(bar);
  }

  /* --- Tabs ---
     DESCRIPTION, PAY WHAT YOU CAN, MISSION. One panel at a
     time; the others carry `hidden`. Arrow keys move between tabs per the
     WAI-ARIA tabs pattern; an already-selected tab is a no-op so a repeat
     tap does not fire a second event. */
  var tabsRoot = root.querySelector('[data-tabs]');
  if (tabsRoot) {
    var tabBtns = Array.prototype.slice.call(tabsRoot.querySelectorAll('[role="tab"]'));
    var selectTab = function (btn, focus) {
      tabBtns.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) btn.focus();
    };
    /* Swipe left/right on the panel switches tabs (AS, 2026-09-12). A
       horizontal move of 48px or more that is clearly more sideways than
       vertical, so a scroll never turns into a tab change. */
    var swipeX = null, swipeY = null;
    var currentTab = function () {
      for (var k = 0; k < tabBtns.length; k++) if (tabBtns[k].getAttribute('aria-selected') === 'true') return k;
      return 0;
    };
    var stepTab = function (dir) {
      var n = currentTab() + dir;
      if (n < 0 || n >= tabBtns.length) return;
      selectTab(tabBtns[n], false);
      ga('pdp_tab_selected', { tab: tabBtns[n].getAttribute('data-tab'), item_id: root.getAttribute('data-product-id'), via: 'swipe' });
    };
    tabsRoot.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swipeX = null; return; }
      swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY;
    }, { passive: true });
    tabsRoot.addEventListener('touchend', function (e) {
      if (swipeX === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - swipeX;
      var dy = e.changedTouches[0].clientY - swipeY;
      swipeX = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      stepTab(dx < 0 ? 1 : -1);
    }, { passive: true });

    tabBtns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-selected') === 'true') return;
        selectTab(b, false);
        ga('pdp_tab_selected', { tab: b.getAttribute('data-tab'), item_id: root.getAttribute('data-product-id') });
      });
      b.addEventListener('keydown', function (e) {
        var n;
        if (e.key === 'ArrowRight') n = i + 1;
        else if (e.key === 'ArrowLeft') n = i - 1;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabBtns.length - 1;
        else return;
        e.preventDefault();
        n = (n + tabBtns.length) % tabBtns.length;
        selectTab(tabBtns[n], true);
        ga('pdp_tab_selected', { tab: tabBtns[n].getAttribute('data-tab'), item_id: root.getAttribute('data-product-id') });
      });
    });
  }

  /* --- Reviews ---
     Four cards ship in the HTML. Everything else comes from the storefront
     API on first demand, which is what makes search and filtering possible
     over the FULL set (586 for Petrichor) rather than the 142 a metafield can
     hold. Cards are built with DOM calls, never innerHTML: the bodies are
     third-party text and go in as textContent. */
  var reviewsAcc = root.querySelector('[data-acc="reviews"]');
  var reviewList = root.querySelector('[data-reviews]');
  var reviewTools = root.querySelector('[data-review-tools]');
  var moreBtn = root.querySelector('[data-reviews-more]');
  var jump = root.querySelector('[data-reviews-jump]');

  if (jump && reviewsAcc) {
    jump.addEventListener('click', function () {
      reviewsAcc.open = true;
      reviewsAcc.scrollIntoView({ block: 'start' });
      ga('reviews_open', { source: 'buy_box', item_id: root.getAttribute('data-product-id') });
      loadReviews();
    });
  }

  var allReviews = null;      // full set once fetched
  var loading = false;
  var ratingFilter = 0;       // 0 = all, otherwise 1-5
  var query = '';
  /* The full set is drawn a page at a time. All 586 at once made the rest of
     the product page unreachable without scrolling past every card (AS,
     2026-09-30). A new search or filter starts again at one page. */
  var PAGE = 10;
  var visible = PAGE;
  var pageBtn = null;

  function starMarkup(rating) {
    var wrap = document.createElement('span');
    wrap.className = 'al-stars';
    var glyphs = document.createElement('span');
    glyphs.className = 'al-stars__glyphs';
    glyphs.setAttribute('role', 'img');
    glyphs.setAttribute('aria-label', rating + ' out of 5 stars');
    var base = document.createElement('span');
    base.className = 'al-stars__base';
    base.textContent = '\u2605\u2605\u2605\u2605\u2605';
    var fill = document.createElement('span');
    fill.className = 'al-stars__fill';
    fill.textContent = '\u2605\u2605\u2605\u2605\u2605';
    fill.style.width = (rating / 5) * 100 + '%';
    glyphs.appendChild(base);
    glyphs.appendChild(fill);
    wrap.appendChild(glyphs);
    return wrap;
  }

  function reviewCard(r) {
    var card = document.createElement('div');
    card.className = 'al-review' + (r.body ? '' : ' al-review--starsonly');

    var head = document.createElement('div');
    head.className = 'al-review__head';
    var name = document.createElement('span');
    name.className = 'al-review__name';
    /* Nameless or placeholder authors read "Anonymous" (AS, 2026-09-14). */
    var author = (r.author || '').trim();
    name.textContent = (!author || /^(verified buyer|anonymous)$/i.test(author)) ? 'Anonymous' : author;
    if (r.verified) {
      var v = document.createElement('span');
      v.className = 'al-review__verified';
      v.textContent = ' Verified';
      name.appendChild(v);
    }
    var date = document.createElement('span');
    date.className = 'al-review__date';
    date.textContent = formatMonth(r.created_at);
    head.appendChild(name);
    head.appendChild(date);

    var stars = document.createElement('div');
    stars.className = 'al-review__stars';
    stars.appendChild(starMarkup(r.rating));

    card.appendChild(head);
    card.appendChild(stars);
    if (r.body) {
      var body = document.createElement('p');
      body.className = 'al-review__body';
      body.textContent = r.body;
      card.appendChild(body);
    }
    return card;
  }

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function formatMonth(iso) {
    var p = String(iso || '').split('-');
    if (p.length < 2) return '';
    return MONTHS[parseInt(p[1], 10) - 1] + ' ' + p[0];
  }

  function matches(r) {
    if (ratingFilter && r.rating !== ratingFilter) return false;
    if (!query) return true;
    var hay = (r.body + ' ' + r.title + ' ' + r.author).toLowerCase();
    return hay.indexOf(query) !== -1;
  }

  /* Once the full set is here, redraw the histogram from IT rather than the
     metafield. Otherwise a bar reading 535 would filter to 505 and the counts
     on screen would contradict the list under them. */
  function syncHistogram() {
    if (!allReviews) return;
    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    allReviews.forEach(function (r) { counts[r.rating]++; });
    var denom = allReviews.length || 1;
    root.querySelectorAll('[data-rating-filter]').forEach(function (row) {
      var n = counts[parseInt(row.getAttribute('data-rating-filter'), 10)] || 0;
      row.querySelector('.al-rsum__count').textContent = n;
      row.querySelector('.al-rsum__fill').style.width = (n / denom) * 100 + '%';
    });
    /* Reconcile the two places still showing the METAFIELD aggregate. That
       number merges the wax-melt sibling (Rain on Pavement: 31 candle + 2 melt
       = 33), so it is larger than anything browsable here. Once the bars are
       clickable they have to agree with the list, and so does every count
       beside them. Goes away for good when the merge does -- card 257. */
    var n = allReviews.length;
    var label = n + ' review' + (n === 1 ? '' : 's');

    var footCount = root.querySelector('[data-agg-count]');
    if (footCount) footCount.textContent = label;

    var sum = allReviews.reduce(function (a, r) { return a + r.rating; }, 0);
    var avg = n ? (sum / n).toFixed(2) : '0';

    var headerValue = root.querySelector('[data-acc="reviews"] > summary .al-stars__value');
    if (headerValue) headerValue.textContent = avg + ' (' + label + ')';

    /* The big score is averaged over the merged set too, so it drifts by a
       hundredth. Rebuild it rather than leave 4.88 above a header saying 4.87. */
    var bigScore = root.querySelector('.al-rsum__avg');
    if (bigScore) {
      bigScore.textContent = avg;
      var outOf = document.createElement('span');
      outOf.className = 'al-rsum__outof';
      outOf.textContent = '/5';
      bigScore.appendChild(outOf);
    }
  }

  function pageButton() {
    if (pageBtn) return pageBtn;
    var wrap = document.createElement('div');
    wrap.className = 'al-reviews__more';
    pageBtn = document.createElement('button');
    pageBtn.type = 'button';
    pageBtn.className = 'al-btn al-btn--secondary al-btn--full';
    pageBtn.addEventListener('click', function () {
      visible += PAGE;
      renderReviews(true);
      ga('reviews_show_more', { item_id: root.getAttribute('data-product-id'), shown: visible });
    });
    wrap.appendChild(pageBtn);
    reviewList.parentNode.insertBefore(wrap, reviewList.nextSibling);
    return pageBtn;
  }

  function renderReviews(keepPage) {
    if (!allReviews) return;
    if (keepPage !== true) visible = PAGE;
    var shown = allReviews.filter(matches);
    reviewList.textContent = '';
    var frag = document.createDocumentFragment();
    shown.slice(0, visible).forEach(function (r) { frag.appendChild(reviewCard(r)); });
    reviewList.appendChild(frag);

    var left = shown.length - visible;
    var btn = pageButton();
    btn.parentNode.hidden = left <= 0;
    if (left > 0) {
      var next = Math.min(PAGE, left);
      btn.textContent = 'Show ' + next + ' more ' + (next === 1 ? 'review' : 'reviews');
    }

    var counter = root.querySelector('[data-review-count]');
    if (counter) {
      counter.textContent = shown.length === allReviews.length
        ? shown.length + (shown.length === 1 ? ' review' : ' reviews')
        : shown.length + ' of ' + allReviews.length + ' reviews';
    }
    root.querySelectorAll('[data-rating-filter]').forEach(function (row) {
      var on = parseInt(row.getAttribute('data-rating-filter'), 10) === ratingFilter;
      row.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function loadReviews() {
    if (allReviews || loading || !reviewList) return Promise.resolve();
    var base = reviewList.getAttribute('data-review-api');
    var handle = reviewList.getAttribute('data-review-handle');
    if (!base || !handle) return Promise.resolve();

    loading = true;
    if (moreBtn) moreBtn.textContent = 'Loading reviews...';

    return fetch(base + encodeURIComponent(handle), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        allReviews = data.reviews || [];
        if (reviewTools) reviewTools.hidden = false;
        if (moreBtn && moreBtn.parentNode) moreBtn.parentNode.removeChild(moreBtn);
        syncHistogram();
        renderReviews();
        ga('reviews_show_all', { item_id: root.getAttribute('data-product-id'), count: allReviews.length });
      })
      .catch(function () {
        /* The four cards already on the page stay. Say what happened rather
           than leave a button that looks broken. */
        if (moreBtn) moreBtn.textContent = 'Reviews could not load. Try again.';
        loading = false;
      });
  }

  if (moreBtn) moreBtn.addEventListener('click', loadReviews);
  if (reviewsAcc) {
    reviewsAcc.addEventListener('toggle', function () {
      if (reviewsAcc.open) loadReviews();
    });
  }

  var searchInput = root.querySelector('[data-review-search]');
  if (searchInput) {
    var searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        query = searchInput.value.trim().toLowerCase();
        renderReviews();
        if (query) ga('reviews_search', { search_term: query });
      }, 150);
    });
  }

  /* The histogram is the filter. Clicking a bar narrows to that rating;
     clicking the active bar clears back to all. */
  root.querySelectorAll('[data-rating-filter]').forEach(function (row) {
    row.addEventListener('click', function () {
      var stars = parseInt(row.getAttribute('data-rating-filter'), 10);
      ratingFilter = (ratingFilter === stars) ? 0 : stars;
      if (!allReviews) { loadReviews().then(renderReviews); return; }
      renderReviews();
      ga('reviews_filter', { filter: ratingFilter || 'all' });
    });
  });

  /* --- PWYC drawer --- */
  var drawer = document.getElementById('pdp-pwyc');
  var dataEl = document.getElementById('pdp-pwyc-data');
  var variantInput = document.getElementById('pdp-variant-id');
  var form = document.getElementById('pdp-form');
  /* Every [data-pwyc-open] opens the drawer: the price row's link and the
     PAY WHAT YOU CAN tab's cost link. */
  var openBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pwyc-open]'));
  var openBtn = openBtns[0] || null;

  if (drawer && dataEl && variantInput) {
    var pwyc = JSON.parse(dataEl.textContent);
    var amountEl = drawer.querySelector('[data-pwyc-amount]');
    var slider = drawer.querySelector('[data-pwyc-slider]');
    var atc = drawer.querySelector('[data-pwyc-atc]');
    var scroll = drawer.querySelector('[data-pwyc-scroll]');
    var priceRowEl = document.getElementById('pdp-price');
    var value = pwyc.anchor;
    var gaThrottle;
    /* Behaviour context the Live events carry (alatreyu-pwyc.js): seconds on
       the page, how many tiers were tried, whether the cost panel was seen.
       Here the panel is inline in the drawer, so opening the drawer is
       seeing it. */
    var tierChanges = 0;
    var sawCost = false;
    var handle = root.getAttribute('data-product-handle') || '';

    /* The slider stops are the dollar tiers that have a variant, derived from
       the price-map KEYS. The range input runs over their indexes, so a stop
       with no variant behind it cannot be produced. idFor() has no fallback:
       a price with no variant returns 0 and add-to-cart refuses, rather than
       quietly charging the $28 anchor for a $21 display (card 259). */
    var tiers = Object.keys(pwyc.prices)
      .map(function (k) { return parseInt(k, 10); })
      .filter(function (n) { return n > 0 && pwyc.prices[String(n)]; })
      .sort(function (a, b) { return a - b; });

    function idFor(v) { return pwyc.prices[String(v)] || 0; }
    function tierAt(i) { return tiers[Math.max(0, Math.min(tiers.length - 1, i))]; }

    var priceLabelEl = document.querySelector('[data-price-label]');

    /* Park the amount over the thumb. Clamped to the track so it never hangs
       off the panel at the floor or the ceiling -- past the clamp it stops
       tracking rather than overflowing. THUMB must match the ::-*-thumb size
       in components.css. */
    var THUMB = 24;

    function positionAmount() {
      if (!amountEl || !slider) return;
      var min = parseFloat(slider.min);
      var max = parseFloat(slider.max);
      var w = slider.clientWidth;
      if (!w || max === min) return;
      var x = THUMB / 2 + ((parseFloat(slider.value) - min) / (max - min)) * (w - THUMB);
      var half = amountEl.offsetWidth / 2;
      amountEl.style.setProperty('--thumb-x', Math.max(half, Math.min(w - half, x)) + 'px');
    }

    /* Payment processing is a rate on the price the customer picks, so the fee
       line and the total both move with the slider. Liquid renders them at the
       anchor; from the first drag onwards these own them. data-base is the sum
       of every OTHER line, so the total never re-adds a stale fee. */
    var feeEl = drawer.querySelector('[data-cost-fee]');
    var totalEl = drawer.querySelector('[data-cost-total]');
    var feeRate = totalEl ? parseFloat(totalEl.getAttribute('data-fee-rate')) : NaN;
    var feeFixed = totalEl ? parseFloat(totalEl.getAttribute('data-fee-fixed')) : NaN;
    var costBase = totalEl ? parseFloat(totalEl.getAttribute('data-base')) : NaN;

    function paintCost(v) {
      if (!feeEl || !totalEl) return;
      if (isNaN(feeRate) || isNaN(feeFixed) || isNaN(costBase)) return;
      /* Round the fee to cents BEFORE adding it, so the total equals the sum
         of the numbers actually on screen. Totalling unrounded values while
         displaying rounded ones left the lines adding to $13.19 against a
         $13.18 total -- a penny that does not add up, on the one panel whose
         job is to be checkable. */
      var fee = Math.round((v * feeRate + feeFixed) * 100) / 100;
      feeEl.textContent = money2(fee);
      totalEl.textContent = money2(costBase + fee);
    }

    function applyValue(v) {
      var id = idFor(v);
      /* No variant at this price: refuse, never substitute another price. */
      if (!id) { if (atc) atc.disabled = true; return; }
      if (atc) atc.disabled = false;
      value = v;
      variantInput.value = id;
      if (slider) slider.setAttribute('aria-valuetext', money(v));
      if (amountEl) amountEl.textContent = money(v);
      positionAmount();
      paintCost(v);
      if (atc) atc.textContent = 'Add to cart · ' + money(v);
      if (priceRowEl) priceRowEl.textContent = money(v);
      /* At the anchor it is still our suggestion; away from it, it is theirs.
         Both strings come from the template -- they are customer copy. */
      if (priceLabelEl) {
        priceLabelEl.textContent = (v === pwyc.anchor)
          ? priceLabelEl.getAttribute('data-label-suggested')
          : priceLabelEl.getAttribute('data-label-chosen');
      }
    }

    function openDrawer() {
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      sawCost = true;
      ga('cost_transparency_opened', { product_handle: handle, seconds_on_page: secs() });
      /* Rows have no measurable geometry until the drawer is visible, so the
         cue has to be painted here rather than on load. */
      paintFade();
      positionAmount();
      if (slider) slider.focus();
    }
    function closeDrawer() {
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
    }

    openBtns.forEach(function (b) { b.addEventListener('click', openDrawer); });
    drawer.querySelectorAll('[data-pwyc-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

    if (slider) {
      /* Re-assert the stops from the derived tiers so Liquid and JS cannot
         disagree; the thumb starts at the anchor when it is one of them. */
      slider.min = 0;
      slider.max = Math.max(0, tiers.length - 1);
      var anchorIndex = tiers.indexOf(pwyc.anchor);
      if (anchorIndex >= 0) {
        slider.value = anchorIndex;
      } else if (tiers.length) {
        /* Anchor has no variant: start honestly at the first real tier. */
        slider.value = 0;
        applyValue(tiers[0]);
      }
      slider.addEventListener('input', function () {
        applyValue(tierAt(parseInt(slider.value, 10)));
        clearTimeout(gaThrottle);
        gaThrottle = setTimeout(function () {
          tierChanges += 1;
          ga('pwyc_tier_selected', {
            product_handle: handle,
            tier_price: value,
            tier_label: money(value),
            tier_change_count: tierChanges,
            seconds_on_page: secs(),
            saw_cost_breakdown: sawCost
          });
        }, 250);
      });
    }

    /* Scroll cue. Rows approaching the bottom edge of the scroll region ramp
       down in opacity, so the list visibly continues past the edge instead of
       looking like it stops there. The ramp is scaled by how much content is
       actually left, so it lands at zero exactly when you reach the end -- it
       can never imply more rows than exist. A solid band did this job before
       and read as "the list ends here", because it hid the very rows that
       signal there is more (AS, 2026-08-29). */
    var FADE_ZONE = 130;
    var FADE_MIN = 0.12;
    var fadeRows = scroll ? scroll.querySelectorAll('.al-cost__line, .al-cost__total') : [];
    var fadeTick;

    function paintFade() {
      if (!scroll || !fadeRows.length) return;
      var left = scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight;
      var strength = left <= 2 ? 0 : Math.min(1, left / FADE_ZONE);
      var edge = scroll.getBoundingClientRect().bottom;
      for (var i = 0; i < fadeRows.length; i++) {
        var row = fadeRows[i];
        var dist = edge - row.getBoundingClientRect().bottom;
        var o = 1;
        if (dist < FADE_ZONE) {
          o = FADE_MIN + (1 - FADE_MIN) * Math.max(0, dist) / FADE_ZONE;
          o = 1 - (1 - o) * strength;
        }
        row.style.opacity = o.toFixed(3);
      }
    }

    if (scroll) {
      scroll.addEventListener('scroll', function () {
        if (fadeTick) return;
        fadeTick = requestAnimationFrame(function () { fadeTick = null; paintFade(); });
      });
      window.addEventListener('resize', function () { paintFade(); positionAmount(); });
    }

    if (atc && form) {
      atc.addEventListener('click', function () {
        var id = idFor(value);
        if (!id) return;
        variantInput.value = id;
        ga('pwyc_add_to_cart', {
          tier_price: value,
          tier_label: money(value),
          tier_change_count: tierChanges,
          seconds_to_add: secs(),
          saw_cost_breakdown: sawCost,
          currency: 'USD',
          value: value,
          items: [{
            item_id: root.getAttribute('data-product-sku') || '',
            item_name: root.getAttribute('data-product-title') || '',
            item_brand: 'Alatreyu',
            price: value,
            quantity: 1
          }]
        });
        if (window.AlatreyuCart) window.AlatreyuCart.add(form); else form.submit();
      });
    }
  } else {
    openBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        /* Same params as the PWYC path above: a shared event name must keep an
           identical shape or its GA4 custom dimensions go null on this path. */
        ga('cost_transparency_opened', {
          product_handle: root.getAttribute('data-product-handle') || '',
          seconds_on_page: secs()
        });
      });
    });
  }
})();
